import { getHostByEnv } from "@reco/service/src/utils/config";
import { useLocale } from "@reco/shared/src/composables/useLocale";

export function useRecoConfig() {
  const {
    public: { recoDevHost, recoDetailsDevHost },
  } = useRuntimeConfig();

  const { hostname } = useRequestURL();
  const route = useRoute();

  const headers = useRequestHeaders();
  const isDev = import.meta.env.DEV;

  const rawLocale = route.query.locale;
  const localeQuery = (Array.isArray(rawLocale) ? rawLocale[0] : rawLocale) || undefined;
  const localeContext = useLocale(headers, localeQuery);

  const recoHostByEnv = getHostByEnv(hostname);
  const recoHost = isDev ? recoDevHost : recoHostByEnv?.host;
  const recoDetailsHost = isDev ? recoDetailsDevHost : "";

  return {
    recoHost,
    recoDetailsHost,
    locale: localeContext.locale.value,
    country: localeContext.country.value,
    language: localeContext.language.value,
  };
}
